module.exports = __webpack_public_path__ + "static/media/profile.84f014f0.jpg";